module.exports = __webpack_public_path__ + "img/trumpet.80f6def.svg";